module.exports = {
      id: "library-usage",
      viewBox: "0 0 37.432 37.472",
      url: "img/" + "sprite.svg#library-usage",
      toString: function () {
        return this.url;
      }
    }